import { AGGREGATE_SCORES, AGGREGATE_SCORES_COLOR, AGGREGATE_SCORES_OTHER, PROGRAM_TYPE_ABBR } from "../../constants";

const GridCellRating = ({ rating, customClass, children, type = PROGRAM_TYPE_ABBR.EAC, isAggregate = false }) => {
    const score = type === PROGRAM_TYPE_ABBR.Other ? AGGREGATE_SCORES_OTHER : AGGREGATE_SCORES;

    return (
        <span
            className={`d-inline-block ${isAggregate ? 'fw-bold' : ''} px-2 ${AGGREGATE_SCORES_COLOR[rating]} ${customClass ?? ''}`}>
            {rating === 'Loading...' ? rating : children || (isAggregate ? `Overall: ${score[rating]}` : score[rating])}
        </span>
    );
};

export default GridCellRating;
